import { render, staticRenderFns } from "./AllIssues.vue?vue&type=template&id=13f5b8cf&scoped=true"
import script from "./AllIssues.vue?vue&type=script&lang=js"
export * from "./AllIssues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f5b8cf",
  null
  
)

export default component.exports